import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	// Paper: {
	// 	padding: theme.spacing(4),
	// },
}));

export default useStyles;
